import { Properties, Traits } from './analyticsTypes';

const getDomain = (email: string) => email.slice(email.indexOf('@') + 1);

export default function sanitizeTraits(traits?: Traits): Properties {
  traits = traits || {};

  const licensesProperties: Properties | undefined = traits.licenses?.reduce(
    (accumulator, license) => ({
      ...accumulator,
      [`license_${license.productType}`]: license.type,
    }),
    {},
  );

  // Spec for these properties: https://wiki.autodesk.com/pages/viewpage.action?pageId=664366824
  return {
    oxygen_user_id: traits.autodeskId || traits.oxygenId,
    oxygen_analytics_id: traits.analyticsId,
    email: typeof traits.email === 'string' ? traits.email : undefined,
    domain:
      typeof traits.email === 'string'
        ? getDomain(traits.email).toLowerCase()
        : undefined,
    is_employee:
      traits.email &&
      typeof traits.email === 'string' &&
      (traits.email.indexOf('@autodesk.com') > 0 ||
        traits.email.indexOf('@plangrid.com') > 0),
    name:
      typeof traits.name === 'string' &&
      traits.name
        .split(' ')
        .map((n) => n.charAt(0))
        .join('')
        .toUpperCase(),
    ...licensesProperties,
  };
}
